/** Must match API QUERY_PAGE_SIZE. Initial list fetches use page 1. */
export const DB_FETCH_PAGE_SIZE = 300;
export const DB_FETCH_INITIAL_PAGE = 1;

export const dbFetchPageQuery = (page: number = DB_FETCH_INITIAL_PAGE): string => (
  `page=${Math.max(1, page)}`
);

/** ERP keeps desk room state in Redux — LLL IndexedDB sync is a no-op here. */
export const syncAppDbCache = () => {};
